import requester from '@/lib/axios';
import { CourseLineSubCategory } from '@/models/CourseLine';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import SubcategoryArea from '@/models/SubcategoryArea';

export interface SubcategoryAreaFilter extends BaseFilters {
  subcategory?: CourseLineSubCategory;
}

const baseUrl = 'subcategory-areas';

export const listSubcategoryAreas = async (
  params: SubcategoryAreaFilter = {},
) => {
  const { data } = await requester().get<JsonApiResponse<SubcategoryArea>>(
    `${baseUrl}/`,
    { params },
  );
  return data;
};
